import { render, staticRenderFns } from "./CustomLabelFilters.vue?vue&type=template&id=10708e24&"
import script from "./CustomLabelFilters.vue?vue&type=script&lang=js&"
export * from "./CustomLabelFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports